<template>
    <div
        class="bg-level w-full"
        :class="[largeComputed == true ? 'large' : 'normal', medium ? 'medium' : '', small ? 'small' : '']"
    >
        <template v-if="sideMenu || canGoBack || isShowLangSwitch">
            <div class="relative">
                <SideMenu v-if="sideMenu"></SideMenu>
                <TopBarNavigation v-if="canGoBack" @onClickBack="onClickBack()" :defaultBackBehavior="defaultBackBehavior"></TopBarNavigation>
                <LangSwitcher
                    v-if="isShowLangSwitch"
                    :customClass='langSwitcherClass'>
                </LangSwitcher>
            </div>
        </template>
        <template v-if="headerTextComputed != null">
            <div v-if="!small" class="default-logo">
                <div class="logo-container text-center">
                    <img src="@/assets/img/logo/jcb-logo@1x.png" alt="JCB Logo" />
                </div>
                <div class="text-lg text-white uppercase text-center font-main-regular" v-html="headerTextComputed"></div>
            </div>
            <div v-else class="flex flex-col items-center p-6">
                <div v-if="logo" class="logo-container text-center mb-5">
                    <img
                        src="@/assets/img/logo/jcb-logo@1x.png"
                        class="w-12 h-auto mx-auto"
                        alt="JCB Logo"
                    />
                </div>
                <div
                    class="w-full text-white uppercase text-lg text-center px-6"
                    :class="[multiLineTitle ? '': 'line-clamp-1']" v-html="headerTextComputed"
                ></div>
            </div>
        </template>
        <template v-else>
            <slot></slot>
        </template>
    </div>
</template>

<script>
import PropsHelper from "@/helper/PropsHelper";
// component
import SideMenu from "../SideMenu/SideMenu.vue";
import TopBarNavigation from "./component/TopBarNavigation.vue";
import LangSwitcher from "./component/LangSwitcher.vue";

export default {
    name: "TopBarBg",
    props: {
        large: {
            type: Boolean,
        },
        medium: {
            type: Boolean,
        },
        small: {
            type: Boolean
        },
        logo: {
            type: Boolean
        },
        canGoBack: {
            type: Boolean
        },
        defaultBackBehavior: {
            type: Boolean,
            default: true
        },
        headerText: {
            type: String,
            default: undefined
        },
        isShowLangSwitch: { type: Boolean },
        sideMenu: { type: Boolean },
        multiLineTitle: {
            type: Boolean
        }
    },
    data: function () {
        return {
            langSwitcherClass: 'absolute top-5 right-4 ',
        };
    },
    components: {
        SideMenu,
        TopBarNavigation,
        LangSwitcher,
    },
    emits: ["onClickBack"],
    computed: {
        largeComputed: function () {
            if (this.large != undefined) {
                return this.large;
            }
            return false;
        },
        headerTextComputed: function () {
            return PropsHelper.getStringProp(this.headerText)
        }
    },
    methods: {
        onClickBack: function () {
            this.$emit("onClickBack")
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/style/base/base.scss";

.bg-level {
    // position: absolute;
    // top: 0px;
    // left: 0px;
    // z-index: 0;
    background-size: 100%, 100%;
    background-repeat: no-repeat;
    background-image: linear-gradient(
        $color-primary-light 0%,
        $color-primary 100%
    );
    &.normal {
        height: $topbar-size-normal;
        background-image: url(~@/assets/img/bg-hero-normal.svg),
            linear-gradient($color-primary-light 0%, $color-primary 100%);
    }

    &.medium {
        height: $topbar-size-medium;
        // background-image: url(~@/assets/img/bg-hero-large.svg),
        background-image: url(~@/assets/img/bg-hero-medium.svg),
            linear-gradient($color-primary-light 0%, $color-primary 100%);
    }

    &.large {
        height: $topbar-size-large;
        background-image: url(~@/assets/img/bg-hero-large.svg),
            linear-gradient($color-primary-light 0%, $color-primary 100%);
    }

    &.small {
        height: 136px;
        background-image: url(~@/assets/img/bg-hero-normal.svg),
            linear-gradient($color-primary-light 0%, $color-primary 100%);
    }

    .default-logo {
        .logo-container {
            padding-top: 42px;
            padding-bottom: 25px;

            img {
                margin-left: auto;
                margin-right: auto;
            }
        }
        .header-text {
            color: #fff;
            text-align: center;
        }
    }
}
</style>
